import React from 'react'

import Warning from '@/components/common/Banner/Warning'
import Markdown from '@/components/markdown/Markdown'

import { useBanner } from '@/hooks/common/useBanner'

import type { MarkdownNodeProps } from '@/types/components/Markdown'

interface Banner {
  children?: React.ReactNode
}

export const Banner: React.FC<Banner> = ({ children }) => {
  return (
    <div className="flex items-center justify-center w-full p-1 bg-accent-400 text-sm font-semibold text-white line-clamp-1">
      {children}
    </div>
  )
}

export const ServerBanner: React.FC = () => {
  const { data: banner } = useBanner()

  const components = {
    a: ({ node, ...props }: MarkdownNodeProps) => (
      <a
        {...props}
        target="_blank"
        rel="noreferrer"
        className="text-white dark:text-white underline hover:opacity-80"
      />
    ),
  }

  if (!banner || !banner.show) {
    return null
  }

  return (
    <Banner>
      <Markdown components={components}>{banner.message}</Markdown>
    </Banner>
  )
}

export { Warning }

export default Banner
